import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { triggerNotification, useGetApiRequests } from "../../../common/CommonExport";
import axios, { AxiosResponse } from "axios";
import { ApplyLeaveContextProps, EmailAnnouncement } from './ApplyLeaveContext.types';
import { useSelector } from "react-redux";
import PopupModal from "../../employee/employee-details/employee-profile/modal/PopupModal";
import { useDispatch } from "react-redux";
import { setLeaveReportPayload, setPermissionCount, setPermissionTimingInString } from "../../../redux/slices/leaveReportPayloadSlice";
import { getCurrentMonthObjects } from "./ApplyLeaveContextHelper";
import { setLeaveReportTotal } from "../../../redux/slices/leaveListSlice";

interface SearchEmailAnnouncementDto {
  isActive: boolean;
  organisationId: number;
  status: string;
}
interface AnnouncementPayload {
  searchEmailAnnouncementDto: SearchEmailAnnouncementDto;
  start: number;
  limit: number;
}
const ApplyLeaveContext = createContext<any | undefined>(undefined);

export const ApplyLeaveProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const userId = useSelector((state: any) => state?.userId?.id);
  const orgId = useSelector((state: any) => state?.organisationId?.id);
  const permissionBalanceCount = useSelector((state: any) => state?.leaveReportPayload?.permissionCount);
  const getLeaveList = useGetApiRequests("getUserLeaveList", "POST");
  const applyLeaveRequest = useGetApiRequests('applyLeaveRequest', 'POST');
  const getAnnouncementsList = useGetApiRequests("employeeFilterAnnouncement", "POST");
  const getLeaveRequestList = useGetApiRequests("leaveRequestList", "GET");
  const getLeaveReportsApi = useGetApiRequests("getLeaveReport", "GET");

  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [leaveList, setLeaveList] = useState<any[]>([]);
  const [leaveBankData, setLeaveBankData] = useState<any[]>([]);
  const [leaveOptions, setLeaveOptions] = useState<any>([])
  const [permissionOption, setPermissionOption] = useState<any>([])
  const [modalerrMessage, setModalErrMessage] = useState('')
  const [popModal, setPopModal] = useState(false)
  const [modalResponse, setModalResponse] = useState('')
  const [modalButtonShow, setmodalButtonShow] = useState(true)
  const [showDate, setShowDate] = useState(false)
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [count, setCount] = useState<number>(0);
  const [pageSize, setPageSize] = useState(10);
  const [isCompletedPermission, setIsCompletedPermission] = useState<boolean>(false)
  const [onLeaveTodayList, setOnLeaveTodayList] = useState<any[]>([]);
  const [onLeaveTodayLoader, setOnLeaveTodayLoader] = useState(false);
  const [onLeaveTodayCount, setOnLeaveTodayCount] = useState(0);

  const [formReset, setFormReset] = useState<() => void>(() => () => { });

  const [announcementList, setAnnouncementList] = useState<EmailAnnouncement[] | undefined>();
  const [loader, setLoader] = useState(true)
  const [leaveLoading, setLeaveLoading] = useState(false);

  const [initialValues, setInitialValues] = useState({
    leaveType: "1",
    leaveDate: {
      startDate: new Date(new Date().setHours(0, 0, 0, 0)),
      endDate: new Date(new Date().setHours(0, 0, 0, 0))
    },
    // leaveDate: [dayjs(), dayjs()]
    // leaveDate: null,
    leaveReason: '',
    leavePolicyId: '',
    leaveDuration: '',
    leaveStatus: '',
    permissionStartTime: "",
    permissionEndTime: "",
    halfDayLeave: false,
  });


  const today = new Date().toISOString().split("T")[0];


  const handleOpenModal = () => {
    setModalOpen(true);
  }
  const handleCloseModal = () => setModalOpen(false);

  useEffect(() => {
    init()
  }, [])
  const init = () => {
    dispatch(setPermissionTimingInString({}))
    setShowDate(false)
    getUsersList()
    getLeaveBankData()
    getLeaveReport(1, 100)
  }


  const getLeaveReport = (page: number, size: number) => {
    setOnLeaveTodayLoader(true);
    const queryParams: any = {
      organisationId: orgId,
      start: (page - 1) * size,
      limit: size,
      leaveStatus: "approved",
      fromDate: today,
      toDate: today,
    };

    dispatch(setLeaveReportPayload(queryParams));

    getLeaveReportsApi("", queryParams)
      .then((response: any) => {
        const totalRecords = response?.data?.meta?.totalRecords || 0;
        setOnLeaveTodayCount(totalRecords);
        dispatch(setLeaveReportTotal(totalRecords));

        const formattedData = response?.data?.data.map((item: any, index: number) => ({
          policyType: item?.policyType,
          employeeName: item?.employeeName,
          fromDate: item?.fromDate,
          toDate: item?.toDate,
          duration: item?.duration,
          status: item?.status,
          reason: item?.reason,
          key: index + 1,
          formattedFromDate: item?.fromDate,
          formattedToDate: item?.toDate,
          lopCount: item?.lopCount,
        }));
        setOnLeaveTodayList(formattedData);
      })
      .catch((err: any) => {
        triggerNotification("error", "", err?.message, "topRight");
      })
      .finally(() => setOnLeaveTodayLoader(false));
  };


  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const getLeaveBankData = async () => {
    setLoader(true)
    const employeeId = userId;
    const organisationId = orgId;
    try {
      const pathParams = {
        employeeId: `${employeeId}/leave-request/list?organisationId=${organisationId}`
      };

      const response = await getLeaveRequestList('', {}, pathParams);

      if (axios.isAxiosError(response)) {
        throw new Error(response.message);
      }
      if (response?.data) {
        setLeaveBankData(response?.data?.data?.employeeLeaveBankDtoList)
        const storeLeaveBankData = response?.data?.data?.employeeLeaveBankDtoList
        const permissionBalance = response?.data?.data?.employeeLeaveBankDtoList
          .filter((item: any) => item.policyName === 'Permission')
          .map((item: any) => item.balance);
        dispatch(setPermissionCount(permissionBalance));
        if (Array.isArray(storeLeaveBankData) && storeLeaveBankData.length > 0) {
        }
        if (storeLeaveBankData?.length) {
          handleGenerateLeaveOptions(storeLeaveBankData);
        }
        setTimeout(() => {
          setLoader(false)
        }, 2000)
      }
    } catch (error) {
      setTimeout(() => {
        setLoader(false)
      }, 2000)
      console.error('Error fetching leave requests:', error);
    } finally {
      setTimeout(() => {
        setLoader(false)
      }, 2000)
    }
  };
  const handleGenerateLeaveOptions = (el: any) => {
    const leaveTypes = el?.map((item: any) => {
      // const trimSpace = item.policyName.replace(/\s+/g, '');
      return {
        value: item.policyName,
        label: `${item.policyName} (${item.balance})`,
        ...item
      };
    });
    const permissionValue = leaveTypes.filter((value: any) => value.policyName === "Permission");
    setPermissionOption(permissionValue || []);

    const filterValue = leaveTypes.filter((value: any) => {
      if (value.policyName !== "Permission") {
        return value
      }
    })

    setLeaveOptions(filterValue || []);
  };

  const getUsersList = async (): Promise<void> => {
    const start: number = currentPage - 1 === 0 ? 0 : currentPage - 1;
    try {
      setLoader(true)
      const payload = {
        searchEmployeeLeaveDto: {
          employeeId: userId,
          organisationId: orgId,

        },
        start: start,
        limit: pageSize,
        "sortBy": "employeeLeavePolicyRequestMapId",
        "sortDirection": "DESC"
      };
      const response = await getLeaveList(payload);
      if (axios.isAxiosError(response)) {
        throw new Error(response.message);
      }
      if (response?.data) {
        const data = response?.data?.data;
        let permissionList: any = [];
        setCount(response?.data?.totalResults);
        const tempUserList = data?.map((item: any) => {

          if (item?.policyName === "Permission" && item?.status !== "declined") {
            permissionList.push(item);
          }
          return {
            duration: item?.duration ?? 0,
            policyName: item?.policyName ?? '-',
            status: item?.status ?? '-',
            startDate: formatDate(item?.startDate) ?? '-',
            endDate: formatDate(item?.endDate) ?? '-',
            lopCount: item?.lopCount ?? '-',
            reason: item?.reason ?? '-',
            employeeLeavePolicyRequestMapId: item.employeeLeavePolicyRequestMapId ?? '',
          };
        });

        const completedPermission = getCurrentMonthObjects(permissionList)
        setIsCompletedPermission(completedPermission)
        setLeaveList(tempUserList);
        setTimeout(() => {
          setLoader(false)
        }, 3000)
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("Error fetching leave list:", error.response?.data || error.message);
        setLoader(false)
      } else {
        console.error("Unexpected error:", error);
        setLoader(false)
      }
      setLeaveList([]);
    } finally {
      setTimeout(() => {
        setLoader(false)
      }, 2000)
    }
  };



  const getAnnouncements = () => {
    const payload: AnnouncementPayload = {
      searchEmailAnnouncementDto: {
        isActive: true,
        organisationId: orgId,
        status: "SENT",
      },
      start: 0,
      limit: 100,
    };
    getAnnouncementsList(payload)
      .then((response) => {
        if (axios.isAxiosError(response)) {
          throw response;
        }
        setAnnouncementList(response?.data);
      })
      .catch((err) => {
        setPopModal(true)
        setmodalButtonShow(false)
        setModalErrMessage(err?.message)
        setModalResponse('error')
        setTimeout(() => {
          handleClosePopUpModal();
          setLoader(false);
        }, 1500)
      });
  };

  const handleClosePopUpModal = () => {
    setPopModal(false)
  }

  const errorMessageModal = (response: any) => {
    setPopModal(true)
    setmodalButtonShow(false)
    setModalErrMessage(response?.response?.data?.message)
    setModalResponse('error');
    setShowDate(false)
    formReset()
    setTimeout(() => {
      handleClosePopUpModal();
      setLoader(false);
    }, 3000)
  }

  const submitLeaveRequest = (payload: any,) => {
    setLoader(true);
    setLeaveLoading(true)
    try {
      applyLeaveRequest(payload)
        .then((res: any) => {
          if ([200, 201, 202, 203, 204, 205].includes(res.status)) {
            init()
            setPopModal(true)
            setmodalButtonShow(false)
            setModalErrMessage(res?.data?.message)
            setModalResponse('success')
            setTimeout(() => {
              handleClosePopUpModal();
              setLoader(false);
              setLeaveLoading(false)

            }, 3000)
          } else {
            errorMessageModal(res)
          }
        })
        .catch((err) => {
          setLeaveLoading(false)

          errorMessageModal(err)
        });
    } catch (error) {
      setLeaveLoading(false)

      console.error('Error submitting leave request:', error);
    } finally {
      setTimeout(() => {
        setLeaveLoading(false)

        setLoader(false)
      }, 2000)
    }

  }

  return <ApplyLeaveContext.Provider value={{
    modalOpen, handleOpenModal, handleCloseModal, getUsersList, getAnnouncements, announcementList, leaveList, initialValues,
    setInitialValues, loader, leaveBankData, submitLeaveRequest, leaveOptions, permissionOption, showDate, setShowDate, init, currentPage, setCurrentPage, pageSize, setPageSize, count, setFormReset, isCompletedPermission, leaveLoading, onLeaveTodayList, onLeaveTodayLoader, onLeaveTodayCount
  }}>{children}
    {popModal && <PopupModal message={modalerrMessage} open={popModal} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButtonShow} />}</ApplyLeaveContext.Provider>;
};

export const useApplyLeave = (): ApplyLeaveContextProps => {
  const context = useContext(ApplyLeaveContext);
  if (!context) {
    throw new Error("useApplyLeave must be used within an ApplyLeaveProvider");
  }
  return context;
};
